import { useState } from 'react';

import { FormSubmitFunction } from 'components/Form';
import { CmsApiEmailCampaignSignupSingleBlockData } from 'modules/cms/api/types/CmsApiEmailCampaignSignupSingle';
import { postJson } from 'utils/http';

import { CmsEmailCampaignSignup } from './CmsEmailCampaignSignup';

type Props = {
  blockId: string;
  data: CmsApiEmailCampaignSignupSingleBlockData;
  isSidebar?: boolean;
};

export function CmsEmailCampaignSignupSingleBlock({
  blockId,
  data: { headline, buttonText, bgImage },
  isSidebar,
}: Props) {
  const [mode, setMode] = useState('initial');

  const onSubmit: FormSubmitFunction<
    CmsApiEmailCampaignSignupSingleBlockData
  > = ({ values, handleError }) => {
    const postBaseUrl = isSidebar
      ? '/data/website/sidebar-email-signup-single/'
      : '/data/website/page-email-signup-single/';
    setMode('submitting');
    postJson(postBaseUrl + blockId, values)
      .then(() => {
        setMode('submitted');
      })
      .catch((e) => {
        handleError(e);
        setMode('initial');
      });
  };

  return (
    <CmsEmailCampaignSignup
      disabled={mode === 'submitting'}
      onSubmit={onSubmit}
      headline={headline}
      buttonText={buttonText}
      isSidebar={isSidebar}
      isSubmitted={mode === 'submitted'}
      bgImage={bgImage}
      qaId="cms-email-campaign-signup-single"
    />
  );
}
